<template lang="pug">
  form(action="#" class="finish column label wrap" onsubmit="return false")
    .row.col-s.wp
      .g6-s.g5.g12-s.col
        label Cliente
        b {{ job.nome_cliente }}
      .g6-s.g4.g12-s.col
        label Forma atendimento
        b {{ job.forma_atendimento }}
      </div>
      .g6-s.g4.g12-s.col
        label Supporter
        b {{ job.nome_doutor }}
    .g12.col.mt
      label Problema
      b(v-html="job.problema.replace(/\\n/g, '<br />')")
    .g10.mt.col
      label Relatório de atendimento
      textarea(v-model="finish.descricao_atendimento" placeholder="Relatório de atendimento")
    .g5.col(style="margin-top:20px")
      label Tempo Trabalhado (hora:min)
      input(v-mask="'##:##'" v-model="finish.duracao_atendimento" @input="valide" placeholder="00:00" required)
    .mapa.g12(v-if="job.mapa_campos && job.mapa_campos.length")
      h3 Campos adicionais
      .row.wp
        Campo(v-for="m of job.mapa_campos" :key="m.nome" v-if="m.etapa == 'encerramento'" :f="m" :up="(v) => finish[m.nome] = v")
    .alert.mt(v-if="show")
      b ATENÇÃO!!!
      |  A duração informada é maior que o atendimento estimado ({{job.criterios_encerramento.duracao_atendimento}}h). Horas extras são permitidas somente com autorização prévia. Se você foi autorizado a fazer horas adicionais você pode manter o valor informado, se você não foi autorizado há grande chance deste valor ser rejeitado na validação do atendimento. Toda hora extra deve ser autorizada antes de ser executada e é sujeita a aprovação.
    .row
      Button(layout="green-go" type="button" :loader="loader" @click="finishJob")
        i.fa.fa-check
        | ENCERRAR JOB
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import Button from "@/components/Button";
import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);
import Campo from "@/components/Campo.vue";

export default {
  name: "Finish",
  props: { modal: Object },
  components: { Button, Campo },
  data() {
    return {
      rat: "",
      job: this.GET_JOB(),
      show: false,
      loader: false,
      finish: {
        arquivo: null,
        descricao_atendimento: "",
        duracao_atendimento: "",
        fez_hora_extra: false,
      },
    };
  },
  methods: {
    ...mapGetters("job", ["GET_JOB"]),
    ...mapActions("job", ["SET_FINISH"]),
    valide() {
      if (this.finish.duracao_atendimento.length == 5) {
        let duracao = parseInt(this.finish.duracao_atendimento.replace(":", ""))
        let criterios = parseInt(this.job.criterios_encerramento.duracao_atendimento.replace(":", ""))
        if (duracao > criterios) this.show = true
        else this.show = false
      } else this.show = false
    },
    async finishJob() {
      if (this.finish.duracao_atendimento) {
        this.loader = true;
        if (this.job.mapa_campos)
          this.job.mapa_campos.map((f) => f.etapa == 'encerramento' && (!this.finish[f.nome] || this.finish[f.nome] == '') ? this.finish[f.nome] = null : false)
        await this.SET_FINISH({
          id: this.job.id,
          duracao_atendimento: this.job.criterios_encerramento.duracao_atendimento,
          payload: this.finish,
        }).then(() => this.modal.cb && this.modal.cb());
        this.modal.show = false;
      } else {
        alert("Preencha todos os campos.");
      }
    },
  }

};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.finish 
  padding-top: 25px
  color: $gray-6
  padding: 10px 4%
  width: 92%
  padding-top: 25px
  padding-bottom: 25px
  max-width: 900px
  label
    @include label
  @media(max-width: $small) 
    padding-bottom: 100px
  @media(min-width: $small) 
    min-width: 600px
    .input
      width: 90%
  .grid-11
    margin-top: 35px
  .grid-12-s
    margin-top: 17px
  button
    margin-top: 55px
  b 
    font-weight: 500
    color: $gray-1
  .alert, .alert b
    background: $red
    color: white
    padding: 12px
    border-radius: 12px
  .mapa
    margin-top: 30px
    h3 
      color: $purple
    
</style>